import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { invalidateAllAutomationQueries } from '../../queries/useAutomationQuery';
import { invalidateAllContactAutomationsQueries } from '../../queries/useContactAutomationsQuery';

export function useUpdateAutomationStepContentMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: (data: Api.IAutomationStepStatus) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		onSuccess: data => {
			invalidateAllAutomationQueries();
			invalidateAllContactAutomationsQueries();
			onSuccess?.(data);
		},
		onError,
		mutationFn: ({ stepStatusId, content }: { stepStatusId: string; content: Api.IRawRichTextContentState }) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationStepStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}/Content`,
				}),
				'PUT',
				content
			);
		},
	});
}
